import {
    COMPARADOR_CLEAR_VEHICLE_DETAIL_TO_COMPARE,
    COMPARADOR_LOAD_SCHEMA_TO_COMPARE
} from './constants'
import initialState from './initialState'

export function loadSchemaToCompare(data, index) {
    return {
        index,
        type: COMPARADOR_LOAD_SCHEMA_TO_COMPARE,
        data: data
    }
}

export function clearVehicleDetails(index) {
    return {
        index,
        type: COMPARADOR_CLEAR_VEHICLE_DETAIL_TO_COMPARE
    }
}

export function reducer(state = initialState, action) {
    if (action.type === COMPARADOR_LOAD_SCHEMA_TO_COMPARE) {
        const { index, data } = action
        const schema = [...state.schema]
        schema[index] = data
        return {
            ...state,
            schema,
            cardIndexMobile: index,
            openModalForm: false
        }
    } else if (action.type === COMPARADOR_CLEAR_VEHICLE_DETAIL_TO_COMPARE) {
        const { index } = action
        const schema = [...state.schema]
        schema[index].vehicleDetails = null
        return {
            ...state,
            schema
        }
    } else {
        return state
    }
}
